import { get, size, some, pick } from "lodash"
import { createSelector } from "reselect"
import { getRawTopic, getSelectedModel, getModel } from "modules/research-topic-root/selectors"
import { getPortfolio, getSelectedModelId } from "modules/portfolio-root/selectors/portfolios"
import { getRawSelectedBase } from "modules/portfolio-root/selectors"

export const getModelIds = createSelector(
  [getSelectedModel, getSelectedModelId, getModel],
  (topicModel, portfolioRootModel, defaultModel) => ({ researchTopic: topicModel || defaultModel, experiments: portfolioRootModel, compare: portfolioRootModel }),
)

export const getBases = createSelector(
  [getRawSelectedBase],
  (portfolioBase) => ({ experiments: portfolioBase, compare: portfolioBase }),
)

export const getResources = createSelector(
  [getRawTopic, getPortfolio],
  (topic, portfolio) => ({ researchTopic: pick(topic, ["id", "name"]), experiments: pick(portfolio, ["id", "shortId", "name"]), compare: pick(portfolio, ["id", "shortId", "name"]) }),
)

export const getComparisonItems = (state) => get(state, "modules.compareSegmentsRoot.comparisonItems")
const getLongShortData = (n) => state => get(state, `global.data.longShortData${n}.data.model.simulation.composition`)

export const getAllLongShortData = createSelector(
  [getLongShortData(0), getLongShortData(1), getLongShortData(2), getLongShortData(3), getLongShortData(4)],
  (data0, data1, data2, data3, data4) => [
    some(data0, hasLongShort),
    some(data1, hasLongShort),
    some(data2, hasLongShort),
    some(data3, hasLongShort),
    some(data4, hasLongShort),
  ],
)

export function hasLongShort({ longShortComposition }) {
  return size(longShortComposition) === 2
}
